module.exports = __webpack_public_path__ + "img/biter-attack-4.3d4de68e.png";